import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CustomDnsBinding, { CustomDnsBindingQueryParams } from 'mbs-ui-shared@models/CustomDnsBinding';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomDnsBindingsService {
  private readonly controllerPath = '/api/customdns/bindings';

  constructor(private http: HttpClient) {}

  public get(params?: CustomDnsBindingQueryParams): Observable<PagedResponse<CustomDnsBinding>> {
    return this.http
      .get<PagedResponse<CustomDnsBinding>>(this.controllerPath, { params })
      .pipe(map((response) => ({ total: response.total, data: response.data.map((entity) => ({ ...entity, id: `${entity?.id}` })) })));
  }

  public getById(id: string): Observable<CustomDnsBinding> {
    return this.http.get<CustomDnsBinding>(`${this.controllerPath}/${id}`).pipe(map((entity) => ({ ...entity, id: `${entity?.id}` })));
  }

  public create(entity: CustomDnsBinding): Observable<CustomDnsBinding> {
    return this.http.post<CustomDnsBinding>(this.controllerPath, entity);
  }

  public update(entity: CustomDnsBinding): Observable<CustomDnsBinding> {
    return this.http.put<CustomDnsBinding>(`${this.controllerPath}/${entity.id}`, entity);
  }

  public deleteBinding(id: string): Observable<null> {
    return this.http.delete<null>(`${this.controllerPath}/${id}`);
  }
}
